module.exports = __webpack_public_path__ + "img/kuzoclass.df4f9eb8.png";